import React from "react";
import { Outlet } from "react-router-dom";

function MainSinner() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default MainSinner;
